module.exports = __webpack_public_path__ + "static/assets/tache-icon.png";